import { render, staticRenderFns } from "./SubRequestAdditionalInformations.vue?vue&type=template&id=40a42440&scoped=true&"
import script from "./SubRequestAdditionalInformations.vue?vue&type=script&lang=js&"
export * from "./SubRequestAdditionalInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a42440",
  null
  
)

export default component.exports